var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6 d-flex align-items-stretch" }, [
          _c("div", { staticClass: "foot-nav" }, [
            _c(
              "div",
              { staticClass: "row justify-content-center align-items-stretch" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-5 col-md-6 d-flex flex-column justify-content-between"
                  },
                  [
                    _c(
                      "router-link",
                      { class: "foot-links", attrs: { to: { name: "index" } } },
                      [
                        _vm._v(
                          "\n                                List of Companies\n                            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      { class: "foot-links", attrs: { to: { name: "index" } } },
                      [
                        _vm._v(
                          "\n                                Legal terms\n                            "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-5 col-md-6 d-flex flex-column justify-content-between"
                  },
                  [
                    _c(
                      "router-link",
                      { class: "foot-links", attrs: { to: { name: "index" } } },
                      [
                        _vm._v(
                          "\n                                Contact Us\n                            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "Raleway min p-white swed-links" },
                      [
                        _c("img", {
                          attrs: { src: "/img/icon/sweden.svg", alt: "" }
                        }),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: { name: "index" } } },
                          [
                            _vm._v(
                              "\n                                    Show site in Swedish\n                                "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(1)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-3" }, [
      _c("div", { staticClass: "foot-logo" }, [
        _c("img", { attrs: { src: "/img/logo-footer.svg", alt: "" } })
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "Raleway min p-white" }, [
        _vm._v("Made with "),
        _c("img", { attrs: { src: "/img/icon/like.svg", alt: "" } }),
        _vm._v(" in Sweden")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-3" }, [
      _c("p", { staticClass: "min-min foot-info p-white" }, [
        _vm._v("Allmän information")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "min foot-info p-white" }, [
        _vm._v("TecknaEl.se ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "min foot-info p-white" }, [
        _vm._v("Orgno: 444344-1235")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }